<template>
  <v-container>
    <v-subheader class="text-h4 font-weight-bold black--text">{{
      $t("navbar.all_trips")
    }}</v-subheader>

    <div class="py-3 d-flex flex-row algin-center justify-space-between" style="width: 100%">
      <v-chip-group
        v-show="filteredTrip == null"
        mandatory
        active-class="primary--text"
        v-model="tab"
      >
        <v-chip v-for="category in categories" :key="category" active-class="primary">
          {{ $t(`login.Trips.${category}`) }}
        </v-chip>
      </v-chip-group>
      <div style="width: 50px" v-show="filteredTrip != null"></div>
      <v-select
        v-if="companies.length > 1"
        :items="companies"
        v-model="companyId"
        item-text="name"
        item-value="id"
        rounded
        clearable
        solo
        dense
        style="max-width: 200px"
        placeholder="Company"
      >
      </v-select>
      <div style="max-width: 300px">
        <v-autocomplete
          v-model="filteredTrip"
          :items="Object.values(trips)"
          dense
          item-text="name"
          return-object
          clearable
          rounded
          solo
          label="Search"
        ></v-autocomplete>
      </div>
      <!-- {{ filteredTrip }}- -->
      <div class="d-flex flex-row">
        <!-- <v-btn-toggle v-model="isGrid" color="primary" dense> -->
        <!-- <v-btn :value="false" icon><v-icon>mdi-view-list</v-icon></v-btn>
          <v-btn :value="true" icon class="mr-5"><v-icon>mdi-view-grid-outline</v-icon></v-btn> -->
        <!-- </v-btn-toggle> -->
        <NewTrip v-if="canCreateTrips" />
        <!-- <NewTrip /> -->
      </div>
    </div>

    <!-- {{ companyId }}--{{ index }}-- -->

    <v-row v-if="filteredTrip">
      <v-col lg="4" xl="3" sm="6" cols="12">
        <TripCard :trip="filteredTrip" @goToTrip="goToTrip" />
      </v-col>
    </v-row>
    <v-row v-else-if="filteredTrips.length > 0">
      <v-col lg="4" xl="3" sm="6" cols="12" v-for="trip in filteredTrips" :key="trip.id">
        <TripCard :trip="trip" @goToTrip="goToTrip" />
      </v-col>
    </v-row>
    <v-card v-else>
      <v-card-title class="mx-auto justify-center">
        {{
          $t("login.Trips.noTrips", {
            current: $t(`login.Trips.${categories[tab]}`).toLowerCase(),
          })
        }}
      </v-card-title>
      <v-card-subtitle></v-card-subtitle>
    </v-card>
  </v-container>
</template>

<script>
import NewTrip from "@/components/NewTrip";
import TripCard from "@/components/TripCard";

export default {
  // name: "Trips",
  components: { NewTrip, TripCard },
  data() {
    return {
      filteredTrip: null,
      isGrid: false,
      companyId: null,
      tab: 0,
      categories: ["travelingNow", "upcoming", "past", "archived"],
      companyFilter: null,
    };
  },
  methods: {
    goToTrip(tripId) {
      console.log("should go to trip with id", tripId);
      this.$router.push({ name: "Itinerary", params: { tripId } });
    },
  },
  computed: {
    companies() {
      return Object.values(this.$store.state.companies);
    },
    trips() {
      if (this.companyId) {
        console.log("getting trips for company ", this.companyId);
        return this.$store.state.userTrips.filter((trip) => trip.company === this.companyId);
      }
      console.log("getting trips");
      return this.$store.state.userTrips;
    },
    canCreateTrips() {
      return Object.keys(this.$store.state.companies).length > 0;
    },
    filteredTrips() {
      const filtered = [];

      const now = new Date().getTime();
      [...this.trips]
        .sort((a, b) => (a.start_date.seconds > b.start_date.seconds ? -1 : 1))
        .forEach((trip) => {
          const startDate = trip.start_date.toDate().getTime();
          const endDate = trip.end_date.toDate().getTime();
          if (this.tab === 0) {
            if (
              trip.archived !== true &&
              ((now >= startDate && now <= endDate) || startDate === 0 || endDate === 0)
            ) {
              filtered.push(trip);
            }
          } else if (this.tab === 1) {
            if (trip.archived !== true && startDate >= now) {
              filtered.push(trip);
            }
          } else if (this.tab === 2) {
            if (trip.archived !== true && endDate <= now) {
              filtered.push(trip);
            }
          } else if (this.tab === 3) {
            if (trip.archived === true) {
              filtered.push(trip);
            }
          }
        });
      return filtered;
    },
  },

  created() {},
};
</script>
